// src/store/slices/registerRegisterRegisterStudentsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchRegisterRegisterStudents = createAsyncThunk(
  "registerRegisterRegisterStudents/fetchRegisterRegisterStudents",
  async (filters, thunkAPI) => {
    try {
      const params = new URLSearchParams();
            const state = thunkAPI.getState(); // Access Redux state

      const token = state.auth.userArray.access_token; // Assuming token is stored in auth slice

console.log(state.auth.userArray.access_token,"state.auth.userArray.access_token");

      const response = await axios.get(
        `https://nanosoft.space/taarteb/public/api/admin/students-to-register`,
          {
  headers: {
      Authorization: `Bearer ${state.auth.userArray.access_token}`,
    },        }
      );
console.log(response.data.data);

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);

const registerRegisterRegisterStudentsSlice = createSlice({
  name: "registerRegisterRegisterStudents",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegisterRegisterStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegisterRegisterStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchRegisterRegisterStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export default registerRegisterRegisterStudentsSlice.reducer;
